import { CopilotControlAuditContent } from 'models/copilot/Processes/ControlEvidenceAudit/copilotControlEvidenceAudit';
import { CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

export class TenantProcessStateControlDocumentationAudit {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversation;

  // the standards the audit runs under (tenant norm ids); empty on a state written before standards
  normIds: number[];

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversation();
    this.normIds = [];
  }
}

export class TenantProcessStateControlDocumentationAuditDTO {
  controlId: number;

  selectedRecommendationIds: number[];

  createdTaskIds: number[];

  conversation: CopilotConversationDTO;

  // Audit period (ISO datetime). Undefined lets the backend default to the current audit year.
  periodStart?: string;

  periodEnd?: string;

  // The standards the audit runs under (tenant norm ids): the panel's choice among the control's
  // linked standards. Empty lets the backend default to every linked standard (and refuse a control
  // linked to none).
  normIds?: number[];

  constructor() {
    this.controlId = 0;
    this.selectedRecommendationIds = [];
    this.createdTaskIds = [];
    this.conversation = new CopilotConversationDTO();
  }
}

export class CopilotControlDocumentationAuditContent extends CopilotControlAuditContent {
  constructor(controlId: number, candidateNormIds: number[] = []) {
    super(controlId, candidateNormIds, CopilotPanelContext.ControlDocumentationAudit);
  }
}
